// extracted by mini-css-extract-plugin
export default {"container":"Intro_container__i2+NU","hero":"Intro_hero__1Gbnr","innerContainer":"Intro_innerContainer__hWHsl","schoolStudents":"Intro_schoolStudents__+++Yg"};